<template>
  <div class="accessibility-declaration">

    <h1>{{ $t('accessibility.accessibility_statement') }}</h1>

    <p>
      {{ $t('accessibility.of') }}
      <br>
      {{ $t('accessibility.address_1') }}
      <br>
      {{ $t('accessibility.address_2') }}
      <br>
      {{ $t('accessibility.address_3') }}
      <br>
      {{ $t('accessibility.address_4') }}
    </p>

    <ul>
      <li>{{ $t('accessibility.contact_website') }}</li>
      <li>{{ $t('accessibility.contact_phone') }}</li>
      <li>{{ $t('accessibility.contact_email') }}</li>
    </ul>

    <h2>{{ $t('accessibility.introduction') }}</h2>
    <p>{{ $t('accessibility.introduction_1') }}</p>

    <h2>{{ $t('accessibility.legal_requirements') }}</h2>
    <p>{{ $t('accessibility.legal_requirements_1') }}</p>

    <h2>{{ $t('accessibility.compliance_accessibility_requirements') }}</h2>
    <p>{{ $t('accessibility.compliance_accessibility_requirements_1') }}</p>
    <p>{{ $t('accessibility.compliance_accessibility_requirements_2') }}</p>
    <ul>
      <li>{{ $t('accessibility.compliance_accessibility_requirements_2_1') }}</li>
      <li>{{ $t('accessibility.compliance_accessibility_requirements_2_2') }}</li>
      <li>{{ $t('accessibility.compliance_accessibility_requirements_2_3') }}</li>
      <li>{{ $t('accessibility.compliance_accessibility_requirements_2_4') }}</li>
      <li>{{ $t('accessibility.compliance_accessibility_requirements_2_5') }}</li>
      <li>{{ $t('accessibility.compliance_accessibility_requirements_2_6') }}</li>
      <li>{{ $t('accessibility.compliance_accessibility_requirements_2_7') }}</li>
    </ul>
    <p>{{ $t('accessibility.compliance_accessibility_requirements_3') }}</p>

    <h2>{{ $t('accessibility.reports_0') }}</h2>
    <p>{{ $t('accessibility.reports_1') }}</p>
    <p>{{ $t('accessibility.reports_contact_1') }}</p>
    <p>{{ $t('accessibility.reports_contact_2') }}</p>
    <p>{{ $t('accessibility.reports_contact_3') }}</p>


    <h2>{{ $t('accessibility.market_0') }}</h2>
    <p>{{ $t('accessibility.market_1') }}</p>
    <p>{{ $t('accessibility.market_2') }}</p>
    <p>{{ $t('accessibility.market_3') }}</p>
    <p>
      {{ $t('accessibility.market_contact_1') }}
      <br>
      {{ $t('accessibility.market_contact_2') }}
      <br>
      {{ $t('accessibility.market_contact_3') }}
      <br>
      {{ $t('accessibility.market_contact_4') }}
      <br>
      {{ $t('accessibility.market_contact_5') }}
      <br>
      {{ $t('accessibility.market_contact_6') }}
      <br>
    </p>

    <h2>{{ $t('accessibility.create_date_0') }}</h2>
    <p>{{ $t('accessibility.create_date_1') }}</p>
    <p>{{ $t('accessibility.create_date_2') }}</p>

  </div>
</template>

<script>
export default {
  name: 'AccessibilityDeclaration'
}
</script>

<style scoped>
.accessibility-declaration {
  padding: 2rem;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// client/components/AccessibilityDeclaration.vue